module.exports = __webpack_public_path__ + "img/logo-full.aca988ec.svg";